import React from 'react';

class Bar extends React.Component {
    render() {
        return (

<>


          {/* ======= Header ======= */}
          <header id="header" className="header fixed-top" data-scrollto-offset={0}>
    <div className="container-fluid d-flex align-items-center justify-content-between">
      <a
        href="/"
        className="logo d-flex align-items-center scrollto me-auto me-lg-0"
      >
        {/* Uncomment the line below if you also wish to use an image logo */}
        {/* <img src="./img/logo.png" alt=""> */}
        <h1>
        I.P.M.S<span>.</span>
        </h1>
      </a>
      <nav id="navbar" className="navbar">
        <ul>
          <li className="dropdown">
            <a href="#">
              <span>Home</span>{" "}
              <i className="bi bi-chevron-down dropdown-indicator" />
            </a>
            <ul>
              <li>
                <a href="/" className="active">Home</a>
              </li>
              <li>
                <a href="/">Our Products</a>
              </li>
              <li>
                <a href="/">Prices</a>
              </li>
              <li>
                <a href="index-4.html">About Us</a>
              </li>
            </ul>
          </li>
          <li>
            <a className="nav-link scrollto" href="/#features">
              Features
            </a>
          </li>
          <li>
            <a className="nav-link scrollto" href="/#testimonials">
            Testimonials
            </a>
          </li>
          <li>
            <a className="nav-link scrollto" href="/#faq">
            FAQ
            </a>
          </li>
          <li>
            <a className="nav-link scrollto" href="/#team">
              Team
            </a>
          </li>
           {/* <li className="dropdown">
            <a href="#">
              <span>Drop Down</span>{" "}
              <i className="bi bi-chevron-down dropdown-indicator" />
            </a>
            <ul>
              <li>
                <a href="#">Drop Down 1</a>
              </li>
              <li className="dropdown">
                <a href="#">
                  <span>Deep Drop Down</span>{" "}
                  <i className="bi bi-chevron-down dropdown-indicator" />
                </a>
                <ul>
                  <li>
                    <a href="#">Deep Drop Down 1</a>
                  </li>
                  <li>
                    <a href="#">Deep Drop Down 2</a>
                  </li>
                  <li>
                    <a href="#">Deep Drop Down 3</a>
                  </li>
                  <li>
                    <a href="#">Deep Drop Down 4</a>
                  </li>
                  <li>
                    <a href="#">Deep Drop Down 5</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="#">Drop Down 2</a>
              </li>
              <li>
                <a href="#">Drop Down 3</a>
              </li>
              <li>
                <a href="#">Drop Down 4</a>
              </li>
            </ul>
        </li> */}
        </ul>
        <i className="bi bi-list mobile-nav-toggle d-none" />
      </nav>
      {/* .navbar */}
      <a className="btn-getstarted scrollto" href="/Service">
        Get Started
      </a>
    </div>
  </header>
  {/* End Header */}


</>

        );
    }
}

export default Bar;